import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  constructor(private http: HttpClient) { }

  videos(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/v1/support/videos`);
  }
}
